import { onlyDigits } from "./masks";

export interface CepLookup {
  cep: string;
  state?: string;
  city?: string;
  neighborhood?: string;
  street?: string;
}

interface BrasilApiCep {
  cep: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
}

/**
 * Consulta CEP direto na BrasilAPI (sem passar pelo `http` do portal, pra não
 * vazar o Authorization pra um terceiro). Retorna o endereço para autopreenchimento.
 * Lança em CEP inexistente/erro de rede — quem chama trata.
 */
export async function lookupCep(cep: string): Promise<CepLookup> {
  const digits = onlyDigits(cep);
  if (digits.length !== 8) throw new Error("CEP inválido");

  const res = await fetch(`https://brasilapi.com.br/api/cep/v1/${digits}`);
  if (!res.ok) throw new Error("CEP não encontrado");

  const data = (await res.json()) as BrasilApiCep;
  return {
    cep: data.cep,
    state: data.state,
    city: data.city,
    neighborhood: data.neighborhood,
    street: data.street,
  };
}
